import React from "react";
import { Switch, Route } from "react-router-dom";
// react-bootstrap components

import HipposAuthNavbar from "../components/Navbars/HipposAuthNavbar.js";
import HipposAuthFooter from "../components/Footers/HipposAuthFooter.js";
import hipposRoutes from "../hipposRoutes.js";

function HipposAuth() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        return <Route path={prop.layout + prop.path} key={key} component={prop.component} />;
      } else {
        return null;
      }
    });
  };
  return (
    <>
      <div className="wrapper wrapper-full-page">
        <HipposAuthNavbar />
        <Switch>{getRoutes(hipposRoutes)}</Switch>
        <HipposAuthFooter />
      </div>
    </>
  );
}

export default HipposAuth;
